import { render } from "./formularioLaborales.vue?vue&type=template&id=1a649578"
import script from "./formularioLaborales.vue?vue&type=script&lang=js"
export * from "./formularioLaborales.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__